import { render, staticRenderFns } from "./WorkRecordsTable.vue.html?vue&type=template&id=274d2994&scoped=true&external"
import script from "./WorkRecordsTable.vue.js?vue&type=script&lang=js&external"
export * from "./WorkRecordsTable.vue.js?vue&type=script&lang=js&external"
import style0 from "./WorkRecordsTable.vue.scss?vue&type=style&index=0&id=274d2994&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d2994",
  null
  
)

export default component.exports